import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFactory = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	fill: "none",
	stroke: "currentColor",
	strokeWidth: 2,
	strokeLinecap: "round",
	strokeLinejoin: "round",
	className: "lucide lucide-factory-icon lucide-factory",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", { d: "M12 16h.01" }),
		/* @__PURE__ */ _jsx("path", { d: "M16 16h.01" }),
		/* @__PURE__ */ _jsx("path", { d: "M3 19a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V8.5a.5.5 0 0 0-.769-.422l-4.462 2.844A.5.5 0 0 1 15 10.5v-2a.5.5 0 0 0-.769-.422L9.77 10.922A.5.5 0 0 1 9 10.5V5a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2z" }),
		/* @__PURE__ */ _jsx("path", { d: "M8 16h.01" })
	]
});
export default SvgFactory;
